// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"bc3f44ea","703":"ff891353"}[chunkId] + ".chunk.js";
};